import { Observable } from 'rxjs';
import { AddSubscriberUserRequest } from 'src/app/models/subscribers/add-subscriber-user-request.model';
import { AddSubscriberUserResponse } from 'src/app/models/subscribers/add-subscriber-user-response.model';
import { CheckSubscriberResponse } from 'src/app/models/subscribers/check-subscriber-response.model';
import { NewSubscriberRequest } from 'src/app/models/subscribers/create-subscribers-request.model';
import { NewSubscriberResponse } from 'src/app/models/subscribers/create-subscribers-responses.model';
import { DeleteSubscriberResponse } from 'src/app/models/subscribers/delete-subscribers-response.model';
import { SubscribersResponse } from 'src/app/models/subscribers/get-subscribers-response.model';
import { UserSubscriberResponse } from 'src/app/models/subscribers/get-subscribers-user-response.model';
import { ParkingZoneResponse } from 'src/app/models/subscribers/parking-zone-response.model';
import { FolioAbonoRequest } from 'src/app/models/subscribers/payment/card-subscriber-folio-request.model';
import { CardSubscriberRequest } from 'src/app/models/subscribers/payment/card-subscriber-request.model';
import { CardSubscriberTransactionResponse } from 'src/app/models/subscribers/payment/card-subscriber-response.model';
import { SubscribersDetailsResponse } from 'src/app/models/subscribers/subscriber-details-response.model';
import { WalletSubscriberResponse } from 'src/app/models/subscribers/users/get-wallet-for-user-subscribers-response.model';

export abstract class SubscribersRepository {
  abstract getAllSubscribers(
    idSubscriber?: number
  ): Observable<SubscribersResponse>;

  abstract createSubscriber(
    newSubscriber: NewSubscriberRequest
  ): Observable<NewSubscriberResponse>;

  abstract checkZoneSubscriber(
    idEnclosure: number,
    idSubscriber?: number
  ): Observable<ParkingZoneResponse>;

  abstract updateSubscriber(
    subscriberId: number,
    updatedSubscriber: NewSubscriberRequest
  ): Observable<NewSubscriberResponse>;

  abstract deleteSubscriber(
    subscriberId: number
  ): Observable<DeleteSubscriberResponse>;

  abstract getUserSubscribers(
    idEnclosure: number
  ): Observable<UserSubscriberResponse>;

  abstract getSubscriberDetails(
    idAbono: number
  ): Observable<SubscribersDetailsResponse>;

  abstract addSubscriberUser(
    subscriberUserData: AddSubscriberUserRequest
  ): Observable<AddSubscriberUserResponse>;

  abstract getSubscriberDataByIdAbono(
    idAbono: number
  ): Observable<CheckSubscriberResponse>;

  abstract getWalletSubscribers(
    idUser: number
  ): Observable<WalletSubscriberResponse>;

  //MARK: PAYMENTS
  abstract paySubscriberById(
    idAbonoUsuario: number,
    request: CardSubscriberRequest
  ): Observable<CardSubscriberTransactionResponse>;

  abstract processSubscriberPaymentCallback(
    callbackData: FolioAbonoRequest
  ): Observable<CardSubscriberTransactionResponse>;
}
